import React from 'react';
import PropTypes from 'prop-types';

const FiletypePresentationPath = ({ fill = '#FA0' }) => {
  return (
    <path
      fill={fill}
      d="M14.644 19l-1.603 3.531c-.114.251.02.469.309.469h.363a.45.45 0 0 0 .374-.237l1.413-3.125v2.112c0 .135.113.25.253.25h.495a.247.247 0 0 0 .252-.25v-2.112l1.414 3.125c.059.131.23.237.374.237h.363c.288 0 .423-.218.309-.469L17.356 19h3.135a.504.504 0 0 0 .509-.5v-7a.51.51 0 0 0-.509-.5H11.51a.505.505 0 0 0-.51.5v7c0 .269.228.5.51.5h3.134zm10.672-9.319c.382.366.684 1.082.684 1.609v15.084c0 .898-.762 1.626-1.701 1.626H7.701C6.762 28 6 27.272 6 26.374V5.626C6 4.728 6.763 4 7.701 4h10.717c.54 0 1.261.293 1.639.654l5.259 5.027zM12 18h8v-6h-8v6zm1.5-.742a.25.25 0 0 0 .253.242h.495a.243.243 0 0 0 .252-.242v-4.016a.249.249 0 0 0-.252-.242h-.495a.244.244 0 0 0-.253.242v4.016zm4-.003c0 .137.113.245.253.245h.495c.145 0 .252-.11.252-.245v-1.51a.248.248 0 0 0-.252-.245h-.495a.245.245 0 0 0-.253.245v1.51zm-2-.011c0 .142.113.256.253.256h.495a.25.25 0 0 0 .252-.256v-2.488a.254.254 0 0 0-.252-.256h-.495a.25.25 0 0 0-.253.256v2.488z"
    />
  );
};

FiletypePresentationPath.propTypes = {
  fill: PropTypes.string,
};

export default FiletypePresentationPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/filetype/filetype-presentation.jsx